import { render, staticRenderFns } from "./AdminAuthLayout.vue?vue&type=template&id=86156452"
import script from "./AdminAuthLayout.vue?vue&type=script&lang=js"
export * from "./AdminAuthLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports